import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { registerIcons } from '@/components/Icon/icons'
import { setupDirectives } from '@/directives/index'
import * as Sentry from '@sentry/vue'

import router from '@/router'
import App from '@/App.vue'

import 'normalize.css/normalize.css'
import '@/assets/font/iconfont.css'
import '@/styles/index.scss'

import 'fs-design/style'
// import { loadingDirective } from "fs-design"

registerIcons()
import 'amfe-flexible'

const pinia = createPinia()
const app = createApp(App)
setupDirectives(app)
app.use(pinia)
app.use(router)
// app.use(loadingDirective)
if (import.meta.env.PROD && import.meta.env.VITE_ENV_MODE === 'PROD') {
  Sentry.init({
    app,
    dsn: 'https://f71dbcc48fb04ba90fd0671ac572e196@sentry.fs.com/32',
    release: 'design-center',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

app.mount('#mainApp')
